import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import {DxSelectBoxModule, DxTextBoxComponent, DxValidatorComponent} from 'devextreme-angular';
import { ValidationRule } from 'devextreme-angular/common';
import { ColorSwatchComponent } from '../color-swatch/color-swatch.component';
import EnumUtils from "../../../shared/enum-utils";

export interface ColorDefinition {
    name: string;
    value: string;
}

@Component({
    selector: 'app-color-select-box',
    standalone: true,
    imports: [CommonModule, DxSelectBoxModule, DxValidatorComponent, DxTextBoxComponent, ColorSwatchComponent],
    templateUrl: './color-select-box.component.html'
})
export class ColorSelectBoxComponent implements OnInit {
    @Input() value: string | undefined;
    @Output() valueChange = new EventEmitter<string>();

    @Input() label = '';
    @Input() validators: ValidationRule[] = [];
    @Input() readOnly: boolean = false;
    @Input() palette: ColorDefinition[] | null = null;

    items: ColorDefinition[] = [];

    ngOnInit() {
        this.initColors();
    }

    private initColors() {
        if (this.palette && this.palette.length > 0) {
            this.items = this.palette;
        } else {
            const getStyle = (name: string) => getComputedStyle(document.body).getPropertyValue(name).trim();

            this.items = EnumUtils.BootstrapColors.map(c => ({
                name: c.name,
                value: c.name,
                color: getStyle(c.var)
            })).filter(c => c.color);
        }
    }

    onValueChanged(e: any) {
        this.value = e.value;
        this.valueChange.emit(this.value);
    }
}
